import { z } from "zod";

import { zSchema } from "../../../../entity";

import type { OperationalErrorOptions } from "~/shared/error";
import { OperationalError } from "~/shared/error";
import { Pagination } from "~/shared/zod";

const zIn = z.object({
  pageOptions: Pagination.Options.zSchema,
});
type In = z.infer<typeof zIn>;

const zOut = zSchema;
type Out = z.infer<typeof zOut>;

const zOutSchema2 = zSchema
  .pick({
    id: true,
    number: true,
    status: true,
    payment: true,
    cost: true,
    moveIsScheduledFor: true,
    createdAt: true,
  })
  .extend({
    contactPersonFullName: zSchema.shape.contactPerson.shape.fullName,
    from: z.string().nonempty(),
    to: z.string().nonempty(),
  });

const zUpdateErrorReason = z.enum(["ORDER_COMPLETED"]);
const UpdateErrorReason = zUpdateErrorReason.Enum;
type UpdateErrorReason = z.infer<typeof zUpdateErrorReason>;

class UpdateError extends OperationalError {
  readonly reason: UpdateErrorReason;

  constructor(reason: UpdateErrorReason, options?: OperationalErrorOptions) {
    super(options);
    this.reason = reason;
    this.message = `Failed to update order.`;
  }
}

export { UpdateError, UpdateErrorReason, zIn, zOut, zOutSchema2, zUpdateErrorReason };
export type { In, Out };
